import FooterFragment = Queries.cms_Footer
import FooterLink = Queries.cms_ComponentUtilsFooterDropdownItem
import FooterLinkList = Queries.cms_ComponentUtilsFooterLinkList
import FooterSocialLink = Queries.cms_ComponentUtilsSocialLink

import { FooterProps, FooterLink as FooterLinkType, SocialLink, LinkList } from '../../components/organisms/footer'

import { mapFragmentToImage } from '../other/images.mapper'
import { mapNavigationLink, sanitizeSlug } from '../link.mapper'

type Maybe<T> = NonNullable<T> | undefined | null

export function mapFooterProps(fragment: FooterFragment): FooterProps {
  const logo = mapFragmentToImage(fragment?.logo)

  const socialLinks: SocialLink[] =
    fragment?.socialLink?.map((socialLink: Maybe<FooterSocialLink>) => ({
      icon: mapFragmentToImage(socialLink?.icon ?? null),
      link: sanitizeSlug(socialLink?.url ?? ''),
      openInNewTab: true,
    })) ?? []

  const mapLink = (cta: Maybe<FooterLink>) => ({
    title: cta?.title ?? '',
    link: mapNavigationLink(cta?.url, cta?.page),
    openInNewTab: Boolean(cta?.openInNewTab),
  })

  const legalLinks: FooterLinkType[] =
    fragment?.legalArea?.map((legalLink: Maybe<FooterLink>) => {
      return mapLink(legalLink)
    }) ?? []

  const linkLists: LinkList[] =
    fragment?.linkList?.map((linkList: Maybe<FooterLinkList>) => {
      const links: FooterLinkType[] =
        linkList?.link?.map((link: Maybe<FooterLink>) => {
          return mapLink(link)
        }) ?? []

      return {
        title: linkList?.title ?? '',
        links,
      }
    }) ?? []

  return {
    logo,
    socialLinks,
    linkLists,
    cta1: mapLink(fragment?.cta1),
    cta2: mapLink(fragment?.cta2),
    legalLinks,
  }
}
